import { render, staticRenderFns } from "./MeasurementsAddOn.vue?vue&type=template&id=ff0d3248&scoped=true&"
import script from "./MeasurementsAddOn.vue?vue&type=script&lang=js&"
export * from "./MeasurementsAddOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0d3248",
  null
  
)

export default component.exports